export const getDateFromString = stringDate => {
  let generatedDate;

  try {
    generatedDate = new Date(stringDate);
  } catch (err) {
    const parts = stringDate.split('/');
    const day = parts[0];
    const monthIndex = parts[1] - 1;
    const yearAndTimeSplit = parts[2].split(' ');
    const year = yearAndTimeSplit[0];
    const hoursSplit = yearAndTimeSplit[1].split(':');
    const hours = hoursSplit[0];
    const minutes = hoursSplit[1];
    const seconds = hoursSplit[2];
    generatedDate = new Date(year, monthIndex, day, hours, minutes, seconds);
  } finally {
    return generatedDate;
  }
};
